(function () {
    function loadScript(src, onload) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = onload;
        script.onerror = function () {
            console.error('Impossible de charger ' + src);
        };
        document.body.appendChild(script);
    }

    function loadRuntime() {
        loadScript('js/jquery-3.5.1.min.js', function () {
            loadScript('js/webflow.js?v=4', function () {
                requestAnimationFrame(function () {
                    window.dispatchEvent(new Event('resize'));
                    window.dispatchEvent(new Event('scroll'));
                });
                loadScript('js/custom.min.js?v=5');
            });
        });
    }

    function scheduleRuntime() {
        setTimeout(loadRuntime, 1200);
    }

    if (document.readyState === 'complete') {
        scheduleRuntime();
    } else {
        window.addEventListener('load', scheduleRuntime, {once: true});
    }
})();
